import { customToast } from "@/components/toast/custom-react-toastify/v1";

export const UTM_FIELDS = [
    { key: 'utm_source', label: '유입 출처', placeholder: 'instagram', suggestions: ['instagram', 'kakaotalk', 'naver_blog', 'youtube', 'threads', 'facebook', 'tiktok'] },
    { key: 'utm_medium', label: '매체', placeholder: 'social', suggestions: ['social', 'bio', 'story', 'reels', 'dm', 'post', 'video'] },
    { key: 'utm_campaign', label: '캠페인', placeholder: '2610_fall_sale' },
    { key: 'utm_term', label: '키워드', placeholder: '선택' },
    { key: 'utm_content', label: '콘텐츠', placeholder: '선택 (예: cardnews_01)' },
];

/**
 * 원본 URL 에 UTM 파라미터를 붙인다. 같은 키가 이미 있으면 덮어쓴다. URL 이 올바르지 않으면 null.
 */
export function buildUrlWithUtm(url, utm) {
    try {
        const result = new URL(url.trim());

        if (result.protocol !== 'http:' && result.protocol !== 'https:') {
            return null;
        }

        if (!UTM_FIELDS.some(({ key }) => utm[key]?.trim())) {
            return url.trim(); // UTM 이 없으면 원본 그대로 (URL 정규화로 바뀌지 않게)
        }

        UTM_FIELDS.forEach(({ key }) => {
            const value = utm[key]?.trim();
            if (value) {
                result.searchParams.set(key, value);
            }
        });
        return result.href;
    } catch (error) {
        return null;
    }
}

export const EMPTY_UTM = Object.fromEntries(UTM_FIELDS.map(({ key }) => [key, '']));

export const MAX_TITLE_LENGTH = 50;
export const MAX_GROUP_LENGTH = 20;

/**
 * 수정 화면용: 저장된 URL 을 UTM 을 뺀 원본 링크와 UTM 값으로 나눈다.
 */
export function splitUtm(url) {
    try {
        const parsed = new URL(url);
        const utm = { ...EMPTY_UTM };
        UTM_FIELDS.forEach(({ key }) => {
            utm[key] = parsed.searchParams.get(key) || '';
            parsed.searchParams.delete(key);
        });
        return { base: Object.values(utm).some(Boolean) ? parsed.href : url, utm };
    } catch (error) {
        return { base: url, utm: { ...EMPTY_UTM } };
    }
}

/**
 * 목록 표시용: 원본 URL 의 호스트와 UTM 값
 */
export function parseUrl(url) {
    try {
        const parsed = new URL(url);
        return {
            host: parsed.hostname.replace(/^www\./, ''),
            utm: UTM_FIELDS
                .map(({ key, label }) => ({ key, label, value: parsed.searchParams.get(key) }))
                .filter(r => r.value),
        };
    } catch (error) {
        return { host: url, utm: [] };
    }
}

export async function copyShortUrl(text) {
    await navigator.clipboard.writeText(text);
    customToast.success('단축 URL 이 복사되었습니다.');
}
